module.exports = __webpack_public_path__ + "img/13.ef0a46f1.jpeg";